import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class FlowMeter extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        size: PropTypes.number
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondaryColor: '#fff',
        size: 50
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.25).toString()} width={(size / 1.25).toString()} viewBox="0 0 300 251.22">
                <g fill={color}>
                    <rect y={66.18} width={300} height={75.13} rx={2.83} ry={2.83} fill={color} />
                    <circle cx={150} cy={103.75} r={100.62} fill={color} />
                    <path
                        d="M150 207.5a103.75 103.75 0 1 1 103.75-103.75A103.87 103.87 0 0 1 150 207.5zm0-201.23a97.49 97.49 0 1 0 97.49 97.49A97.6 97.6 0 0 0 150 6.27z"
                        fill={secondaryColor}
                    />
                    <path d="M193.33 72.45h-86.66a6.265 6.265 0 0 1 0-12.53h86.65a6.265 6.265 0 1 1 0 12.53z" fill={secondaryColor} />
                </g>
            </svg>
        );
    }
}

export default withTheme(FlowMeter);



// WEBPACK FOOTER //
// ./data/common/iconsvg/FlowMeter.js